import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-vehicle-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent],
  templateUrl: './vehicle-form.component.html',
  styleUrl: './vehicle-form.component.scss'
})
export class VehicleFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  Vehicle = {
    SelectType: 'insert',
    ESS_VehicleMasterId: 0,
    VehicleName: null,
    //ClassName: null,
    IsLocal: false,
    IsOutStation: false,
    IsActive: true,
  }

  constructor(
    private toast: ToastService,
    private expense: ExpenseService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.Vehicle.ESS_VehicleMasterId = this.ID;
    if(this.Vehicle.ESS_VehicleMasterId == undefined){
      this.Vehicle.ESS_VehicleMasterId = 0;
    }
    if (this.ID > 0) {
      this.ESS_VehicleMasterSelect();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if(this.Vehicle.IsLocal || this.Vehicle.IsOutStation){
        this.ESS_VehicleMaster_InsertUpdate();
      }else{
        this.toast.show({message:'Please select Local or OutStation or both',type:toastTypeEnum.warning});
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_VehicleMasterSelect() {
    this.isDisabled = true;
    this.expense.ESS_VehicleMasterSelect({ ESS_VehicleMasterId: this.Vehicle.ESS_VehicleMasterId, SelectType: 1 }).subscribe({
      next: (response) => {
        this.Vehicle = response.Table[0];
        //this.Vehicle.ClassName = response.Table1.map((e:any) => e.ClassName).toString();
        this.Vehicle.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_VehicleMaster_InsertUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if((this.Vehicle.ESS_VehicleMasterId == 0 && this.common.PageRight.IsAdd) || (this.Vehicle.ESS_VehicleMasterId > 0 && this.common.PageRight.IsEdit)){
        if (result) {
          this.isDisabled = true;
          this.expense.ESS_VehicleMaster_InsertUpdate(this.Vehicle).subscribe({
            next: (response) => {
              if (response.Error_Code == '418' || response.Error_Code == '419') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close(true);
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }else{
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  close() {
    this.activeModal.close();
  }
}
